import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { measureService } from '../services/measure.service';
import type { ListRecordsResponse, Measure } from '../services/measure.service';

export function useMeasures(options?: {
  page?: number;
  pageSize?: number;
  search?: string;
  sort?: string;
  filters?: Record<string, any>;
  enabled?: boolean;
}) {
  const {
    page = 1,
    pageSize = 50,
    search,
    sort,
    filters = {},
    enabled = true,
  } = options || {};

  return useQuery<ListRecordsResponse<Measure>>({
    queryKey: ['measures', page, pageSize, search ?? '', sort ?? '', filters],
    queryFn: () => measureService.find({ page, pageSize, search, sort, filters }),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    placeholderData: keepPreviousData,
  });
}

export function useMeasure(id: string, options?: { enabled?: boolean }) {
  const { enabled = true } = options || {};

  return useQuery<Measure>({
    queryKey: ['measure', id],
    queryFn: () => measureService.findById(id),
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
